<template>
  <div class="night-sky-container" ref="mainContainer">
    <div class="stars-layer">
      <div v-for="n in 50" :key="'star'+n" class="star" :style="generateStarStyle()"></div>
      <div class="shooting-star"></div>
      <div class="shooting-star"></div>
    </div>

    <div class="content-section">
      <div ref="thanksRef" class="thanks-text">
        <p class="quote-line">“Gracias, mamá y papá, por ser mi raíz, mi fuerza y mi refugio.”</p>
        <p class="quote-line">Todo lo que soy y lo que seré es reflejo del amor con el que me han criado.</p>
        <p class="quote-line">Este día no solo celebra mi vida, sino todo lo que ustedes han hecho por ella.”</p>
      </div>
    </div>

   

   
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'FairytaleCover',
  setup() {
    const image = ref(null)
    const textRef = ref(null)
    const thanksRef = ref(null)
    const mainContainer = ref(null)

    const generateStarStyle = () => {
      const size = Math.random() * 2 + 1 + 'px'
      return {
        top: Math.random() * 100 + '%',
        left: Math.random() * 100 + '%',
        width: size,
        height: size,
        animationDelay: Math.random() * 5 + 's',
        opacity: Math.random()
      }
    }

    onMounted(() => {
      // Animación frases arriba
      gsap.fromTo(thanksRef.value.querySelectorAll('.quote-line'),
        { opacity: 0, y: 30, filter: 'blur(10px)' },
        {
          opacity: 1, y: 0, filter: 'blur(0px)',
          duration: 1.5, stagger: 0.6, ease: 'power2.out',
          scrollTrigger: { trigger: thanksRef.value, start: 'top 85%', once: true }
        }
      )

      // Animación imagen
      gsap.fromTo(image.value,
        { opacity: 0, scale: 0.95 },
        { 
          opacity: 1, scale: 1,
          duration: 2, ease: 'expo.out',
          scrollTrigger: { trigger: image.value, start: 'top 80%', once: true }
        }
      )

      // Animación firma
      gsap.fromTo(textRef.value,
        { opacity: 0, y: 20 },
        { 
          opacity: 1, y: 0,
          duration: 1.5, ease: 'power2.out',
          scrollTrigger: { trigger: textRef.value, start: 'top 90%', once: true }
        }
      )
    })

    return { image, textRef, thanksRef, mainContainer, generateStarStyle }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:italic,wght@0,400;1,700&family=Josefin+Sans:wght@300;400&display=swap');

.night-sky-container {
  width: 100%;
  min-height: 40vh;
  background: linear-gradient(to bottom, #050510 0%, #02021a 50%, #000000 100%);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  padding: 60px 0;
}

/* --- ESTRELLAS --- */
.stars-layer {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.star {
  position: absolute;
  background: white;
  border-radius: 50%;
  box-shadow: 0 0 5px white;
  animation: twinkle 3s infinite ease-in-out;
}

@keyframes twinkle {
  0%, 100% { opacity: 0.3; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.2); }
}

/* --- ESTRELLAS FUGACES --- */
.shooting-star {
  position: absolute;
  top: 0;
  left: 50%;
  width: 2px;
  height: 2px;
  background: white;
  box-shadow: 0 0 10px 2px white;
  border-radius: 50%;
  opacity: 0;
  animation: shoot 8s infinite;
}

.shooting-star:nth-child(2) {
  left: 20%;
  animation-delay: 4s;
}

@keyframes shoot {
  0% { transform: translateX(0) translateY(0) rotate(-45deg) scale(0); opacity: 0; }
  10% { opacity: 1; transform: translateX(-100px) translateY(100px) rotate(-45deg) scale(1); }
  20% { transform: translateX(-500px) translateY(500px) rotate(-45deg) scale(0); opacity: 0; }
  100% { transform: translateX(-500px) translateY(500px) rotate(-45deg) scale(0); opacity: 0; }
}

/* --- CONTENIDO --- */
.content-section {
  width: 100%;
  max-width: 800px;
  padding: 40px 25px;
  text-align: center;
  z-index: 10;
}

.quote-line {
  color: #e0e0e0;
  font-family: 'Playfair Display', serif;
  font-style: italic;
  font-size: 1.4rem;
  line-height: 1.6;
  margin-bottom: 20px;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.2);
}

/* --- MARCO DE LA FOTO --- */
.photo-section {
  padding: 20px 0;
  z-index: 5;
}

.frame-container {
  padding: 10px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(164, 130, 80, 0.5); /* Bordes dorados sutiles */
  border-radius: 15px;
  box-shadow: 0 0 40px rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
}

.photo {
  max-width: 320px; /* Ajuste para que no sea gigante */
  height: auto;
  border-radius: 10px;
  display: block;
}

/* --- FIRMA --- */
.firma {
  font-family: 'Josefin Sans', sans-serif;
  text-transform: uppercase;
  letter-spacing: 5px;
  color: #a48250;
  font-size: 0.9rem;
}

.firma span {
  display: block;
  margin-top: 15px;
  font-family: 'titulos', serif; /* Tu fuente */
  font-size: 3.5rem;
  color: #fff;
  text-transform: none;
  letter-spacing: 0;
  text-shadow: 0 0 20px rgba(255, 255, 255, 0.3);
}

@media (max-width: 768px) {
  .quote-line { font-size: 1.1rem; }
  .photo { max-width: 280px; }
  .firma span { font-size: 2.8rem; }
}
</style>